import { render, staticRenderFns } from "./productRecord.vue?vue&type=template&id=07131e05&scoped=true&"
import script from "./productRecord.vue?vue&type=script&lang=js&"
export * from "./productRecord.vue?vue&type=script&lang=js&"
import style0 from "./productRecord.vue?vue&type=style&index=0&id=07131e05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07131e05",
  null
  
)

export default component.exports